import $ from 'jquery';
import numeral from 'numeral';

class InvoiceFeeTable {

  constructor(form) {
    this.form = form;
    this.invoice = form.invoice;
    this.$table = form.$form.find('#invoice_fees');
    this.$tbody = this.$table.children('tbody');
    this.colCount = 6;
  }

  isEmpty() {
    return !this.invoice.fees.length;
  }

  emptyRow() {
    this.$tbody.empty();

    var $tr = $('<tr/>').addClass('empty-fees').appendTo(this.$tbody);
    var $td = $('<td/>')
      .attr('colspan', this.colCount)
      .addClass('text-muted')
      .appendTo($tr);
    $td.text('This invoice has no fees');
  }

  buildRows() {
    this.$tbody.empty();
    let _this = this;

    this.invoice.fees.forEach(function(item, index, array) {
      let $tr = _this.buildRow(item);
      _this.$tbody.append($tr);
    });
    this.recalculateFees();
  }

  insertRow(ix, fee) {
    let $trEmpty = this.$tbody.find('tr.empty-fees');
    if ($trEmpty.length) {
      this.buildRows();
    }
    else {
      $trEmpty.remove();
      let $tr = this.buildRow(fee);
      if (ix > 0) {
        this.$tbody.find('tr:eq(' + (ix-1) + ')').after($tr);
      }
      else {
        this.$tbody.append($tr);
      }
    }
  }

  buildRow(fee) {
    let $tr = $('<tr/>')
      .attr('data-uuid', fee.uuid)
      .data('item', fee);

    if (fee.selected) {
      $tr.addClass('bg-light-success');
    }

    let $td = $('<td/>').appendTo($tr);
    let $p = $('<p/>').addClass('form-control-plaintext')
      .appendTo($td);
    $('<strong/>').text(fee.name).appendTo($p);
    $('<small/>').text(fee.summary()).appendTo($td);

    let $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'fee_uuid[]')
      .attr('data-field', 'uuid')
      .val(fee.uuid)
      .appendTo($td);

    $td = $('<td/>').addClass('text-center')
      .appendTo($tr);
    let txt = numeral(fee.rate).format('$0,0.[000]');
    if (fee.adjuster_rate) txt += '/' + numeral(fee.adjuster_rate).format('$0,0.[000]');
    if (fee.type === 'per_unit') txt += '/unit';
    $('<p/>').addClass('form-control-plaintext')
      .text(txt)
      .appendTo($td);

    $td = $('<td/>').addClass('text-center fee-quantity')
      .appendTo($tr);
    let $input = $('<input/>').attr('type', 'text').addClass('form-control')
      .attr('name', 'fee_quantity[]')
      .attr('data-field', 'quantity')
      .val(fee.quantity)
      .appendTo($td);
    let $blank = $('<p/>').addClass('form-control-plaintext')
      .text('-')
      .appendTo($td);

    if (fee.type === 'per_unit') {
      $blank.addClass('d-none');
    }
    else {
      $input.addClass('d-none');
    }

    $td = $('<td/>').addClass('text-center').appendTo($tr);
    $p = $('<p/>').addClass('form-control-plaintext fee-discount')
      .appendTo($td);

    $td = $('<td/>').addClass('text-center').appendTo($tr);
    $p = $('<p/>').addClass('form-control-plaintext fee-total')
      .appendTo($td);

    $td = $('<td/>').addClass('text-center')
      .appendTo($tr);
    $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'fee_selected[]')
      .attr('data-field', 'selected')
      .val(fee.selected ? 1 : 0)
      .appendTo($td);
    let $ig = $('<div/>').addClass('checkbox m-b-none m-t-sm')
      .appendTo($td);
    let $label = $('<label/>').appendTo($ig);
    let $chk = $('<input/>').attr('type', 'checkbox')
      .attr('data-selected', fee.selected)
      .appendTo($label);
    $chk.prop('checked', fee.selected);

    return $tr;
  }

  init() {
    this.setupEvents();

    if (this.isEmpty()) {
      this.emptyRow();
    }
    else {
      this.buildRows();
    }
  }

  toggleCheckbox(chk) {
    let $chk = $(chk);
    let $hidden = $chk.closest('td').find('input:hidden');
    let $tr = $chk.closest('tr');
    let fee = $tr.data('item');
    fee.selected = $chk.is(':checked');

    $hidden.val(fee.selected ? 1 : 0);

    if (fee.selected) {
      $tr.addClass('bg-light-success');
    }
    else {
      $tr.removeClass('bg-light-success');
    }
    this.recalculateFees();
  }

  recalculateFees() {
    let $rows = this.$tbody.find('tr');
    let discount_rate = parseFloat($('#discount').val());
    if (!isFinite(discount_rate)) {
      discount_rate = 0;
    }
    discount_rate /= 100;

    $rows.each(function(ix) {
      let $tr = $(this);
      let fee = $tr.data('item');
      let $total = $tr.find('p.fee-total');
      let $discount = $tr.find('p.fee-discount');

      if (fee.selected) {

        let quantity = parseFloat($tr.find('input[data-field=quantity]').val());
        if (!isFinite(quantity)) {
          quantity = 0;
        }
        let total = fee.rate;
        let discount = discount_rate;

        if (fee.type === 'per_unit') {
          if (fee.included) {
            quantity -= fee.included;
            if (quantity < 0) quantity = 0;
          }
          total *= quantity;
        }

        if (fee.discountable && discount > 0) {
          discount *= total;
          total -= discount;

          discount = numeral(discount).format('$0,0.[000]');
          $discount.text(discount);
        }

        total = numeral(total).format('$0,0.[000]');
        $total.text(total);
      }
      else {
        $discount.text('');
        $total.text('');
      }
    });
    this.form.calculateTotal();
  }

  getRowData($tr) {
    let data = {};
    $tr.find('[data-field]').each(function(ix) {
      let $el = $(this);
      data[$el.data('field')] = $el.val();
    });
    return data;
  }

  highlightIfDirty($tr) {
    let fee = $tr.data('item');
    if (fee.is_new) return;

    let data = this.getRowData($tr);
    if (fee.isDirty(data)) {
      $tr.addClass('warning');
    }
    else {
      $tr.removeClass('warning');
    }
  }

  setupEvents() {
    let _this = this;

    this.$table.on('click', 'input:checkbox[data-selected]', function(e) {
      _this.toggleCheckbox(e.currentTarget);
    }).on('keyup', 'tbody input[type=text]', function(e) {
      _this.recalculateFees();
    });

    this.form.$form.on('keyup', '#discount', function(e) {
      _this.recalculateFees();
    });
  }
}

export default InvoiceFeeTable;
